import { combineReducers } from 'redux'
import UI from 'store/ui/ui.slice';
import WASMApplication from 'store/wasmApplication/wasmApplication.slice';
import WASMApplicationResult from './wasmApplication/wasmApplicationResult.slice';

export default combineReducers({
    UI,
    WASMApplication,
    WASMApplicationResult
})